import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { queryClient } from '@/queries';
import { CreateReleaseNotePayload, UpdateReleaseNotePayload } from '@/api/apis/release-notes';
import { resourceReleaseNotesQueryKeys } from './release-notes.keys';

export const useCreateResourceReleaseNoteMutation = (product: string) => {
  return useMutation({
    mutationFn: (payload: CreateReleaseNotePayload) => api.resourceReleaseNotes.createReleaseNote(product, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: resourceReleaseNotesQueryKeys.all(product),
      });
    },
  });
};

export const useUpdateResourceReleaseNoteMutation = (product: string) => {
  return useMutation({
    mutationFn: ({ releaseNoteId, payload }: { releaseNoteId: string; payload: UpdateReleaseNotePayload }) =>
      api.resourceReleaseNotes.updateReleaseNote(product, releaseNoteId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: resourceReleaseNotesQueryKeys.all(product),
      });
    },
  });
};

export const useDeleteResourceReleaseNoteMutation = (product: string) => {
  return useMutation({
    mutationFn: (releaseNoteId: string) => api.resourceReleaseNotes.deleteReleaseNote(product, releaseNoteId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: resourceReleaseNotesQueryKeys.all(product),
      });
    },
  });
};
